import { Link } from 'react-router-dom'

const IMAGES = [
  'level-up-frameless-walk-in-shower-screen-melbourne-01.webp',
  'level-up-frameless-corner-shower-screen-marble-melbourne-02.webp',
  'level-up-frameless-shower-screen-gold-fixtures-melbourne-01.webp',
  'level-up-black-framed-corner-shower-screen-marble-melbourne-01.webp',
  'level-up-sliding-glass-shower-screen-melbourne-01.webp',
  'level-up-brass-framed-shower-screen-melbourne-01.webp',
  'level-up-frameless-shower-screen-marble-melbourne-01.webp',
  'level-up-frameless-corner-shower-screen-melbourne-01.webp',
  'level-up-frameless-shower-screen-timber-bench-melbourne-01.webp',
  'level-up-black-framed-corner-shower-screen-melbourne-01.webp',
  'level-up-frameless-shower-screen-over-bath-melbourne-01.webp',
  'level-up-frameless-walk-in-shower-screen-melbourne-04.webp',
  'level-up-frameless-corner-shower-screen-melbourne-02.webp',
  'level-up-frameless-walk-in-shower-screen-melbourne-03.webp',
  'level-up-black-framed-shower-screen-melbourne-01.webp',
  'level-up-frameless-shower-screen-double-vanity-melbourne-01.webp',
  'level-up-frameless-fixed-panel-shower-screen-marble-melbourne-01.webp',
]

export default function Gallery() {
  return (
    <main className="container page">
      <nav className="breadcrumbs"><Link to="/">Home</Link> / <span>Gallery</span></nav>
      <header className="page-head">
        <h1>Gallery</h1>
        <p>Real bathrooms fitted with our screens and glass — from frameless walk-ins to black-framed corners.</p>
      </header>
      <div className="masonry">
        {IMAGES.map((f) => (
          <img key={f} src={`/images/portfolio/${f}`} alt={f.replace(/level-up-|-melbourne.*|\.webp/g, '').replaceAll('-', ' ')} loading="lazy" />
        ))}
      </div>
    </main>
  )
}
